var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.8vw",
    height: "0.8vw",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08279 11.3263L7.37935 9.57515L9.67592 11.3263L8.81471 8.48428L11.1113 6.84797H8.29798L7.37935 3.86244L6.46073 6.84797H3.64743L5.944 8.48428L5.08279 11.3263ZM7.37935 13.6228C6.58512 13.6228 5.83874 13.4721 5.1402 13.1707C4.44166 12.8693 3.83403 12.4602 3.3173 11.9435C2.80058 11.4268 2.3915 10.8191 2.09008 10.1206C1.78865 9.42204 1.63794 8.67566 1.63794 7.88143C1.63794 7.0872 1.78865 6.34082 2.09008 5.64228C2.3915 4.94374 2.80058 4.33611 3.3173 3.81938C3.83403 3.30265 4.44166 2.89358 5.1402 2.59215C5.83874 2.29073 6.58512 2.14001 7.37935 2.14001C8.17358 2.14001 8.91997 2.29073 9.61851 2.59215C10.317 2.89358 10.9247 3.30265 11.4414 3.81938C11.9581 4.33611 12.3672 4.94374 12.6686 5.64228C12.9701 6.34082 13.1208 7.0872 13.1208 7.88143C13.1208 8.67566 12.9701 9.42204 12.6686 10.1206C12.3672 10.8191 11.9581 11.4268 11.4414 11.9435C10.9247 12.4602 10.317 12.8693 9.61851 13.1707C8.91997 13.4721 8.17358 13.6228 7.37935 13.6228Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleIcon);
export default __webpack_public_path__ + "static/media/Style_Icon.e58699c81914df57ce987fe21d05bdce.svg";
export { ForwardRef as ReactComponent };